/* eslint-disable */
import '@dw/js-sdk';
import {
  m_getUrlKey,
  isEnvMobile,
  isIOS,
  getPageName,
  getFromPage,
} from '@/common/utils';
import { cnzz } from '@edu-fe/cnzz';
import { getIdentityContext } from './identityContext';

/**
 * 统一获取埋点上报的端类型（type）：PC / ios / android
 * @param {boolean} [mobile] 可选。显式指定当前是否为移动端组件；若缺省则自动按运行环境判定
 */
export function getDeviceType(mobile) {
  const isMobile = typeof mobile === 'boolean' ? mobile : isEnvMobile();
  return isMobile ? (isIOS() ? 'ios' : 'android') : 'PC';
}

/**
 * 获取默认页面路由上下文（page_name / from_item）
 */
export function getRouteContext() {
  return {
    page_name: getPageName(),
    from_item: getFromPage(),
  };
}

/**
 * 参数重载与上下文补齐：
 * 1. 支持 (event, name, payload) 3参数与 (event, name, type, payload) 4参数；
 * 2. 自动合并全局路由上下文（page_name / from_item），业务显式传入的参数可覆盖默认值。
 */
function resolveCollectArgs(type, args) {
  let resolvedType = getDeviceType();
  let rawPayload = {};

  if (typeof type === 'object' && type !== null && args === undefined) {
    rawPayload = type;
  } else {
    if (type) resolvedType = type;
    if (args) rawPayload = args;
  }

  const payload = {
    ...getRouteContext(),
    ...rawPayload,
  };

  return { resolvedType, payload };
}

// 按需附带身份，事件参数由调用方在触发时快照保存。
export async function collectWithIdentity(event, name, type, args) {
  const { resolvedType, payload } = resolveCollectArgs(type, args);
  try {
    const identity = await getIdentityContext();
    dwCollectData(event, name, resolvedType, { ...payload, ...identity });
  } catch (error) {
    console.warn('[tracking] event report failed', error);
  }
}

window.dw.setAppKey('b9abcee31dd6ee28'); // 必须调用此方法，传入你产品的唯一标识
window.dw.setDebug(
  process.env.NODE_ENV_PACK_ENV === 'test' ||
    process.env.NODE_ENV === 'development',
); // 在调试时开启为true,线上环境请务必开启为false

/**
 * 数据埋点上报统一入口
 * 支持多态入参：(event, name, payload) 或 (event, name, type, payload)
 */
export function dwCollectData(event, name, type, args) {
  const { resolvedType, payload } = resolveCollectArgs(type, args);
  const obj = { type: resolvedType, name };
  Object.assign(obj, payload);
  dwOnEvent(event, obj);
  // 同时上报log到cnzz
  cnzz(`${name}`, `${event}`, `${JSON.stringify(obj)}`);
}

/*
处理页面跳转前上报事件丢失,提前设置好页面跳转时要上报的事件
https://npm.wps.cn/package/@dw/js-sdk
setAppEndExtraData方法
*/
export function setAppEndExtraData(event, name, type, args) {
  const { resolvedType, payload } = resolveCollectArgs(type, args);
  const obj = { type: resolvedType, name };
  Object.assign(obj, payload);

  if (process.env.NODE_ENV_PACK_ENV !== 'prod') {
    console.log(`[setAppEndExtraData 埋点][${event}]`, obj);
  }
  window.dw.setAppEndExtraData(event, obj);
  // 同时上报log到cnzz
  cnzz(`${name}`, `${event}`, `${JSON.stringify(obj)}`);
}

function dwOnEvent(event, obj) {
  window.dw.setChannel(m_getUrlKey('chn') || 'web');
  if (process.env.NODE_ENV_PACK_ENV !== 'prod') {
    console.log(`[dwOnEvent 埋点][${event}]`, obj);
  }
  window.dw.onEvent(event, obj);
}
// 提供公共方法，供表单使用
window.dwOnEvent = dwOnEvent;

function setDwCustomPublicAttrs(key, value) {
  window.dw.setCustomPublicAttrs(key, value);
}

export default {
  getIdentityContext,
  getDeviceType,
  getRouteContext,
  collectWithIdentity,
  dwCollectData,
  setAppEndExtraData,
  setDwCustomPublicAttrs,
};
